import { ControllerPaletteColor } from './__palette-color';

export enum ControllerOutlinedInputColor {
  DefaultFg = ControllerPaletteColor.Gray200, //
  DisabledFg = ControllerPaletteColor.Gray400, //
  DisabledBg = ControllerPaletteColor.Gray950, //
  DefaultBorder = ControllerPaletteColor.Gray600, //
  FocusBorder = ControllerPaletteColor.Ngb500, //
  HoverBorder = ControllerPaletteColor.Gray600, //
  DisabledBorder = ControllerPaletteColor.Gray950, //
  ErrorBorder = ControllerPaletteColor.Red500, //
  AdornmentFg = ControllerPaletteColor.Ngb500,
  ErrorIconFill = ControllerPaletteColor.Red500,
}
